import { PlusIcon } from '@heroicons/react/24/outline';
import { Button } from '../../../components/ui/button.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { SearchEntity } from '../../../server/types/search-types.ts';
import { useCustomerBasis } from '../../customer-detail/hooks/use-customer-basis.ts';
import { DialogStateManager } from '../../dialog/dialog-provider.tsx';
import { TraskCreateDialog } from '../../tasks/components/task-create-dialog.tsx';

type Props = {
    itemTitle: string;
    customerId: string | undefined;
};

export const InventoryActions = ({ itemTitle, customerId }: Props) => {
    const { t } = useLocale();
    const { data: customerBasics } = useCustomerBasis({ customerId });

    return (
        <Button
            variant="primary"
            icon={PlusIcon}
            onClick={() => {
                DialogStateManager.show(TraskCreateDialog, {
                    description: itemTitle,
                    links: customerId
                        ? [
                              {
                                  modelType: SearchEntity.Customer,
                                  modelId: customerId,
                                  title: customerBasics?.customerName || '',
                              },
                          ]
                        : undefined,
                });
            }}
        >
            {t('header__new_task', { ns: 'product-details' })}
        </Button>
    );
};
